import React, {
  FC, ReactNode, useEffect, useState,
} from 'react';
import Radio, { RadioProps }
  from '@/pages/MarketReportsPreviewPage/components/MarketReportModal/RadioGroup/Radio/Radio';

export interface RadioGroupProps {
  options: RadioProps[];
  defaultValue: string;
  onChange?: (value: string) => void;
}

const RadioGroup: FC<RadioGroupProps> = ({
  options,
  defaultValue,
  onChange,
}: RadioGroupProps) => {
  const [value, setValue] = useState<string>(defaultValue);

  useEffect(() => {
    if (!onChange) {
      return;
    }
    onChange(defaultValue);
  }, []);

  const changeHandler = (val: string): void => {
    setValue(val);
    if (!onChange) {
      return;
    }
    onChange(val);
  };

  const renderRadio = (option: RadioProps): ReactNode => (
    <Radio {...option} onClick={changeHandler} isActive={option.value === value} />
  );

  return (
    <div>
      {options.map(renderRadio)}
    </div>
  );
};

export default RadioGroup;
